import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginatePipe } from 'src/app/pipes/paginate.pipe';
import { PipeModule } from 'src/app/pipes/pipe-module';
import { AdminMantenimientoParametrosBackview } from './admin-mantenimiento-parametros.component.backview';
import { NgxSpinnerModule } from "ngx-spinner";
import { MatDatepickerModule, MatNativeDateModule } from '@angular/material';
import { MatMenuModule } from '@angular/material/menu';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  declarations: [AdminMantenimientoParametrosBackview
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatPaginatorModule,
    HeaderModule,
    FooterModule,
    PipeModule,
    NgxSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule
  ],
  exports: [
    AdminMantenimientoParametrosBackview]
})
export class AdminMantenimientoParametrosModule { }
